import SidebarSearch from "./widgets/SidebarSearch";
import ProductCategories from "./widgets/ProductCategories";
import PriceRange from "./widgets/PriceRange";
import ProductBrands from '@/components/shared/sidebars/widgets/ProductBrands';
import ProductTags from '@/components/shared/sidebars/widgets/ProductTags';
import {useTranslations} from 'next-intl';

export default function ProductSidebar({
      onSearch,
      searchInput,
      currency,
      priceFromInput,
      priceToInput,
      priceRanges,
      onPriceRemove,
      onPriceChange,
      categories,
      brands,
      onCategorySelect,
      onSubcategorySelect,
      categoryInput,
      subcategoryInput,
      onBrandSelect,
      brandInput,
      onTagSelect,
      tagInput,
      resetFilters,
      isFetching
      }) {
  const t = useTranslations('catalog');
  return (
      <aside className="sidebar ltn__shop-sidebar">
        <SidebarSearch onSearch={onSearch} searchInput={searchInput}/>
        <PriceRange
            currency={currency}
            priceFromInput={priceFromInput}
            priceToInput={priceToInput}
            priceRanges={priceRanges}
            onPriceRemove={onPriceRemove}
            onPriceChange={onPriceChange}
        />
        <ProductTags
            onTagSelect={onTagSelect}
            tagInput={tagInput}
        />
        <ProductCategories
            categories={categories}
            onCategorySelect={onCategorySelect}
            onSubcategorySelect={onSubcategorySelect}
            categoryInput={categoryInput}
            subcategoryInput={subcategoryInput}
        />
        <ProductBrands
            brands={brands}
            onBrandSelect={onBrandSelect}
            brandInput={brandInput}
        />
        <div className="reset-filter">
          <button
              onClick={resetFilters}
              title={t('resetFilters')}
              disabled={isFetching}
          >
            <span>{t('resetFilters')}</span>
          </button>
        </div>
      </aside>
  );
};
